import { ClickAwayListener, Drawer } from '@material-ui/core'
import type { PropsWithChildren } from 'react'
import { makeStyles, Theme } from '@material-ui/core/styles'
interface PreviewDrawer {
  open: boolean
  onClose: () => void
  innerModalOpen?: boolean
}

const useStyles = makeStyles<Theme>((theme) => ({
  drawerPaperClass: {
    transition: 'smooth',
    overflowY: 'scroll',
    width: 550,
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
}))

const PreviewDrawer = ({ open, onClose, children, innerModalOpen }: PropsWithChildren<PreviewDrawer>) => {
  const classes = useStyles()
  return (
    <ClickAwayListener
      mouseEvent={open ? 'onClick' : false}
      onClickAway={() => {
        if (!innerModalOpen) {
          onClose()
        }
      }}
    >
      <Drawer
        anchor="right"
        open={open}
        onClose={onClose}
        variant="persistent"
        ModalProps={{
          disableEnforceFocus: innerModalOpen,
        }}
        PaperProps={{ elevation: 6, className: classes.drawerPaperClass }}
      >
        {children}
      </Drawer>
    </ClickAwayListener>
  )
}

export default PreviewDrawer
